export default __webpack_public_path__ + "static/media/coding_icon.ba7a79c6.png";